const initialState = {
  status: "invalid",
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "EXPERTS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "EXPERTS_SUCCESS":
      return {
        ...state,
        status: "success",
        data: payload.data,
        meta: payload.meta,
      };
    case "EXPERTS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
